import { Observable, of } from 'rxjs';
import { InsightsRepository } from '../domain/insights/repository';

import HttpClient from '../utils/http-client';

export class InsightsRepositoryImplementation extends InsightsRepository {
    getInsights(uid: string, cid: string | null, insight: string, period: string): Observable<any> {
        const httpClient = new HttpClient(uid, cid);
        return httpClient.get(`/insights/hub?period=${period}`);
    }
}
